// components
import { createTheme } from "@mui/material/styles";

// base styles
import colors from "assets/mavric-theme/base/colors";
import breakpoints from "assets/mavric-theme/base/breakpoints";
import typography from "assets/mavric-theme/base/typography";
import boxShadows from "assets/mavric-theme/base/boxShadows";
import borders from "assets/mavric-theme/base/borders";
import globals from "assets/mavric-theme/base/globals";

// helper functions
import boxShadow from "assets/mavric-theme/functions/boxShadow";
import hexToRgb from "assets/mavric-theme/functions/hexToRgb";
import linearGradient from "assets/mavric-theme/functions/linearGradient";
import pxToRem from "assets/mavric-theme/functions/pxToRem";
import rgba from "assets/mavric-theme/functions/rgba";
import card from "assets/mavric-theme/components/card";
import cardMedia from "assets/mavric-theme/components/card/cardMedia";
import cardContent from "assets/mavric-theme/components/card/cardContent";
import button from "assets/mavric-theme/components/button";
import iconButton from "assets/mavric-theme/components/iconButton";
import input from "assets/mavric-theme/components/form/input";
import inputLabel from "assets/mavric-theme/components/form/inputLabel";
import inputOutlined from "assets/mavric-theme/components/form/inputOutlined";
import textField from "assets/mavric-theme/components/form/textField";
import menu from "assets/mavric-theme/components/menu";
import menuItem from "assets/mavric-theme/components/menu/menuItem";
import buttonBase from "assets/mavric-theme/components/buttonBase";
import select from "assets/mavric-theme/components/form/select";
import tabs from "assets/mavric-theme/components/tabs";
import tab from "assets/mavric-theme/components/tabs/tab";
import radio from "assets/mavric-theme/components/form/radio";
import svgIcon from "assets/mavric-theme/components/svgIcon";
import checkBox from "assets/mavric-theme/components/form/checkbox";
import switchButton from "assets/mavric-theme/components/form/switchButton";
import tableContainer from "assets/mavric-theme/components/table/tableContainer";
import tableHead from "assets/mavric-theme/components/table/tableHead";
import tableCell from "assets/mavric-theme/components/table/tableCell";
import popover from "assets/mavric-theme/components/popover";
import link from "assets/mavric-theme/components/link";
import container from "assets/mavric-theme/components/container";
import dialog from "assets/mavric-theme/components/dialog";
import dialogTitle from "assets/mavric-theme/components/dialog/dialogTitle";
import dialogContent from "assets/mavric-theme/components/dialog/dialogContent";
import dialogContentText from "assets/mavric-theme/components/dialog/dialogContentText";
import dialogActions from "assets/mavric-theme/components/dialog/dialogActions";
import autocomplete from "assets/mavric-theme/components/form/autocomplete";

export default createTheme({
  breakpoints: { ...breakpoints },
  palette: { ...colors },
  typography: { ...typography },
  boxShadows: { ...boxShadows },
  borders: { ...borders },
  functions: {
    boxShadow,
    hexToRgb,
    linearGradient,
    pxToRem,
    rgba,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...globals,
        ...container,
      },
    },
    MuiCard: { ...card },
    MuiCardMedia: { ...cardMedia },
    MuiCardContent: { ...cardContent },
    MuiButton: { ...button },
    MuiIconButton: { ...iconButton },
    MuiInput: { ...input },
    MuiInputLabel: { ...inputLabel },
    MuiOutlinedInput: { ...inputOutlined },
    MuiTextField: { ...textField },
    MuiMenu: { ...menu },
    MuiMenuItem: { ...menuItem },
    MuiButtonBase: { ...buttonBase },
    MuiSelect: { ...select },
    MuiTabs: { ...tabs },
    MuiTab: { ...tab },
    MuiRadio: { ...radio },
    MuiSvgIcon: { ...svgIcon },
    MuiCheckbox: { ...checkBox },
    MuiSwitch: { ...switchButton },
    MuiTableContainer: { ...tableContainer },
    MuiTableHead: { ...tableHead },
    MuiTableCell: { ...tableCell },
    MuiPopover: { ...popover },
    MuiLink: { ...link },
    MuiDialog: { ...dialog },
    MuiDialogTitle: { ...dialogTitle },
    MuiDialogContent: { ...dialogContent },
    MuiDialogContentText: { ...dialogContentText },
    MuiDialogActions: { ...dialogActions },
    MuiAutocomplete: { ...autocomplete },
    
  },
});
